var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrapper position-relative"
  }, [_c('img', {
    attrs: {
      "src": require("./images/sample_bg_01.jpg"),
      "alt": "",
      "width": "100%"
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/sample_bg_02.jpg"),
      "alt": "",
      "width": "100%"
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/sample_bg_03.jpg"),
      "alt": "",
      "width": "100%"
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/sample_bg_04.jpg"),
      "alt": "",
      "width": "100%"
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/sample_bg_05.jpg"),
      "alt": "",
      "width": "100%"
    }
  }), _c('div', {
    staticClass: "next-btn",
    on: {
      "click": _vm.handleNext
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }